export enum LinkOpenTypes {
    Inside = 0,
    NewTab = 1,
    Replace = 2,
}
